import { render } from "./GeneralAirportStatisticView.vue?vue&type=template&id=04d28d7e&scoped=true"
import script from "./GeneralAirportStatisticView.vue?vue&type=script&lang=js"
export * from "./GeneralAirportStatisticView.vue?vue&type=script&lang=js"

import "./GeneralAirportStatisticView.vue?vue&type=style&index=0&id=04d28d7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d28d7e"]])

export default __exports__